export const API_URL = process.env.GATSBY_API_URL;
export const CALDAV_URL = process.env.GATSBY_CALDAV_API_URL;
export const PHONE_PROVISION_URL = process.env.PHONE_PROVISION_URL;
